<template>
  <div id="app">
    <v-navigation></v-navigation>
    <div id="article" class="flex overflow">
      <div id="main" class="overflow">
        <router-view id="contentx"/>
        <!-- <v-footer></v-footer> -->
      </div>
      <pdf-viewer id="pdf" v-if="pdf" class="overflow"/>
    </div>
  </div>
</template>

<script>
import PdfViewer from '@/components/PDFViewer.vue'

export default {
  name: 'App',
  data() {
    return {
      pdf: false,
      test: 1,
      userData: null,
      authService: null,
      loginFailed: false,
      loginError: null,
    }
  },
  components: {
    PdfViewer
  },
  created() {
    console.log('Hey we just reloaded')
    document.addEventListener('keydown', function(e) {
      if (e.key.toUpperCase()==='S' && e.ctrlKey) {
        e.preventDefault()
        console.log('Document keydown', e.key, e.ctrlKey)
        window.vue.$store.dispatch('saveFsData')
      }
    }, {capture: true})
  },
  // methods: {
  //   acquireToken: function() {
  //     console.log(this.$msal.acquireToken({scopes: ['api://246a5a88-f394-4565-8b55-3ef75e778ba8/access_as_user']}))
  //   },
  //   check: async function() {
  //     var result = await this.$msal.signIn()
  //     console.log(typeof(result))
  //   },
  // }
}
</script>

<style>
html * {
  box-sizing: border-box;
  font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;
}
html {
  height: 100%;
}
body {
  height: 100%;
  margin: 0;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;

  height: 100%;
  display: flex;
  flex-direction: column;
}
#nav a.router-link-exact-active {
  color: #6feeb3;
}
#nav a.router-link-partial-active {
  color: red;
}

.flex {
  display: flex;
}
.flex-column {
  flex-direction: column;
}
.flex-end {
  justify-content: flex-end;
}
.overflow {
  overflow: auto;
}
#main {
  /* display: flex;
  flex-direction: column; */
  flex: 1;
  padding: 1em;
}
#article {
  flex-grow: 1;
}
#pdf {
  flex: 1;
}
</style>
